function ajaxforsvg(svgPaths) {
  svgPaths.forEach(svg => {
    const ajax = new XMLHttpRequest()
    ajax.open('GET', svg, true)
    ajax.send()
    ajax.onload = function(e) {
      const div = document.createElement('div')
      div.innerHTML = ajax.responseText
      document.body.insertBefore(div, document.body.childNodes[0])
    }
  })
}

module.exports = ajaxforsvg



// WEBPACK FOOTER //
// ./scripts/modules/ajaxforsvg.js